"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_MODES = exports.CONFIRM_MODAL_KEY = exports.SKYBASE_AUTH_SILENT_REDIRECT_KEY = exports.STATES = exports.O_AUTH_MODALS_KEY = exports.oAuthAPI = exports.DEFAULT_PAGE_SIZE = exports.O_AUTH_STATE_KEY_NAME = exports.MODULE_NAME = void 0;
var MODULE_NAME = 'skybase-oauth';
exports.MODULE_NAME = MODULE_NAME;
var O_AUTH_STATE_KEY_NAME = 'oAuth';
exports.O_AUTH_STATE_KEY_NAME = O_AUTH_STATE_KEY_NAME;
var DEFAULT_PAGE_SIZE = 10;
exports.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
var oAuthAPI = {
  USERS: '/api/users',
  ROLES: '/api/roles',
  PERMISSIONS: '/api/permissions',
  PERMISSION_SETS: '/api/permissionsets',
  CLIENTS: '/api/clients',
  TENANTS: '/api/tenants',
  APIS: '/api/apis',
  scopes: function scopes(apiId) {
    return "/api/apis/".concat(apiId, "/scopes");
  },
  OPENID_CONFIGURATION: '/.well-known/openid-configuration'
};
exports.oAuthAPI = oAuthAPI;
var O_AUTH_MODALS_KEY = 'oAuthModals';
exports.O_AUTH_MODALS_KEY = O_AUTH_MODALS_KEY;
var STATES = {
  NORMAL: 'normal',
  LOADING: 'loading',
  ERROR: 'error'
};
exports.STATES = STATES;
var SKYBASE_AUTH_SILENT_REDIRECT_KEY = 'skybase-auth-redirect-key';
exports.SKYBASE_AUTH_SILENT_REDIRECT_KEY = SKYBASE_AUTH_SILENT_REDIRECT_KEY;
var CONFIRM_MODAL_KEY = 'confirm-modal';
exports.CONFIRM_MODAL_KEY = CONFIRM_MODAL_KEY;
var APP_MODES = {
  NORMAL: 'normal',
  LOCAL_SDK: 'local-sdk',
  LOCAL_BACKEND: 'local-backend'
};
exports.APP_MODES = APP_MODES;
//# sourceMappingURL=constants.js.map